import React from "react";
import { Identifiable, List } from "@planzone/dto";

import { Props } from "./types";
import styles from "./styles.scss";

function getPaths(list: Identifiable<List>): string[] {
  return list.parentList
    ? [list.name, ...getPaths(list.parentList)]
    : [list.name];
}

function Hierarchy(props: Props) {
  return (
    <div className={styles.hierarchy}>
      {getPaths(props.list).map((name) => (
        <span key={name}>{name}</span>
      ))}
    </div>
  );
}

export { Hierarchy };
